var _defs, _circle, _line, _line2, _line3, _circle2, _path, _line4, _line5, _line6, _path2, _path3, _line7, _polygon, _path4, _circle3, _polygon2, _path5, _circle4, _polyline, _path6, _path7, _path8, _path9, _path10, _polyline2, _path11, _path12, _path13, _polyline3, _line8, _line9, _line10, _line11, _line12, _line13, _polygon3, _polyline4, _rect, _path14, _path15, _line14, _line15, _line16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakeOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2,.cls-4{stroke:#0b1320;stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-4{fill:none;}.cls-2{stroke-dasharray:2.39 3.98;}.cls-3{fill:#0b1320;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 135,
    cy: 33.52,
    r: 28.52
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 135,
    y1: 66.74,
    x2: 135,
    y2: 95.34
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 202.49,
    y1: 78.94,
    x2: 182.26,
    y2: 99.17
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 67.51,
    y1: 78.94,
    x2: 87.74,
    y2: 99.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 228,
    cy: 53.44,
    r: 28.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.25,55.36l8.19,8.2a2.32,2.32,0,1,1-3.28,3.28L240.35,69a2.32,2.32,0,0,1-3.28,3.28L236,71.21a2.32,2.32,0,0,1-3.28,3.28l-1.09-1.09a2.32,2.32,0,1,1-3.28,3.28L215.18,63.54c-3.86-3.86-1.86-8.82-4.18-11.14"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 229.97,
    y1: 58.64,
    x2: 238.16,
    y2: 66.84
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 227.23,
    y1: 62.47,
    x2: 235.98,
    y2: 71.21
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 224.5,
    y1: 66.29,
    x2: 231.61,
    y2: 73.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.8,61.92l2.57-2.57c2.19-2.19,1.36-7.36,3.55-9.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.57,39.92l-2.18,2.18c-2.19,2.19-4.37,0-6.56,2.19l-8.34,8.34a.77.77,0,0,0,0,1.09l.55.55a3.08,3.08,0,0,0,4.37,0l4.37-4.37a7.73,7.73,0,0,0,10.94,0"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 224.5,
    y1: 46.62,
    x2: 220.58,
    y2: 42.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "252.65 46.62 247.5 52.1 234.36 38.96 239.45 33.55 252.65 46.62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.76,61.73l-2.37,2.38a2.22,2.22,0,0,0,.54,2.73,2.3,2.3,0,0,0,2.73.55l-.54.54a2.32,2.32,0,1,0,3.28,3.28l.54-.55a2.32,2.32,0,1,0,3.28,3.28h0a2.28,2.28,0,0,0,.55,2.74,2.32,2.32,0,0,0,2.73.54L226.69,75"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 241.31,
    cy: 38.96,
    r: 0.77
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "203.35 49.22 208.5 54.69 221.64 41.56 216.55 36.15 203.35 49.22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.91,41.56a.78.78,0,1,1,.77.77A.78.78,0,0,1,213.91,41.56Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 42,
    cy: 53.44,
    r: 28.52
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "38.26 54.74 38.09 49.87 45.91 49.87 45.75 54.74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.87,42.61a3.32,3.32,0,0,1,3.34,3.29S37,40,37,39.46a2,2,0,0,0-2-1.93,2.13,2.13,0,0,0-1.79,1.13l-2.42,5.9h0A3.35,3.35,0,0,1,33.87,42.61Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.11,53.85a7.36,7.36,0,0,1,7.42,7.31S38,48.08,38,46.85a4.33,4.33,0,0,0-4.36-4.29,4.73,4.73,0,0,0-4,2.51l-5.37,13.1h0A7.43,7.43,0,0,1,31.11,53.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.11,53.85a7.31,7.31,0,1,0,7.42,7.31A7.36,7.36,0,0,0,31.11,53.85Zm0,11.85a4.55,4.55,0,1,1,4.61-4.54A4.58,4.58,0,0,1,31.11,65.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.13,42.61a3.32,3.32,0,0,0-3.34,3.29S47,40,47,39.46a2,2,0,0,1,2-1.93,2.15,2.15,0,0,1,1.79,1.13l2.41,5.9h0A3.34,3.34,0,0,0,50.13,42.61Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.9,53.85a7.36,7.36,0,0,0-7.42,7.31s.5-13.08.5-14.31a4.32,4.32,0,0,1,4.36-4.29,4.75,4.75,0,0,1,4,2.51l5.36,13.1h0A7.44,7.44,0,0,0,52.9,53.85Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "45.91 48.38 45.75 53.25 38.26 53.25 38.09 48.38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.9,53.85a7.31,7.31,0,1,0,7.42,7.31A7.36,7.36,0,0,0,52.9,53.85Zm0,11.85a4.55,4.55,0,1,1,4.61-4.54A4.58,4.58,0,0,1,52.9,65.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.91,162v35.84l-27.85,17.07H109.94L82.09,197.81V162L57.68,178.42a7.81,7.81,0,0,0-3.43,6.46v72.33A7.78,7.78,0,0,0,62,265H208a7.78,7.78,0,0,0,7.78-7.79V184.88a7.81,7.81,0,0,0-3.43-6.46Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.88,103.5a7.78,7.78,0,0,0-7.79,7.78v86.53l27.85,17.07h50.12l27.85-17.07V111.28a7.78,7.78,0,0,0-7.79-7.78Z"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "73.74 245.51 109.94 214.88 160.06 214.88 196.26 245.51"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 160.06,
    y1: 214.88,
    x2: 214.87,
    y2: 181.28
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.54,
    y1: 181.53,
    x2: 109.94,
    y2: 214.88
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.37,
    y1: 124.26,
    x2: 118.29,
    y2: 124.26
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.37,
    y1: 140.96,
    x2: 165.63,
    y2: 140.96
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.37,
    y1: 163.24,
    x2: 152.32,
    y2: 163.24
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.37,
    y1: 185.52,
    x2: 135,
    y2: 185.52
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "133.13 41.62 153.06 41.62 153.06 22.94 145.58 15.47 133.13 15.47 133.13 41.62"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "145.58 15.47 145.58 22.94 153.06 22.94"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.94,
    y: 40.37,
    width: 6.28,
    height: 11.21
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.22,50.33h26.7c0-2.68-5.5-5-11.78-5h-11"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.22,41.62h4.34a8.92,8.92,0,0,1,3.28.56A11.22,11.22,0,0,1,135,45.3"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.14,
    y1: 28.05,
    x2: 149.04,
    y2: 28.05
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.14,
    y1: 32.36,
    x2: 146.46,
    y2: 32.36
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.14,
    y1: 36.68,
    x2: 143.09,
    y2: 36.68
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeOffer);
export default __webpack_public_path__ + "static/media/makeOffer.f32d72b996755ca74987f6af58fbef7c.svg";
export { ForwardRef as ReactComponent };